<template>
	<div class="etiquetas" v-click-outside="close">

		<div v-for="(etiqueta, i) in arrayEtiquetas" :key="i" class="etiqueta bg-secondary">

			<fa class="c-pointer" icon="times" @click="$delete(value, i); checkEtiquetas({delete:true})"></fa>
			{{ etiqueta }}

		</div>

		<div class="input-etiqueta-wrapper">

			<input
				ref="input"
				type="text"
				:placeholder="placeholder"
				@keydown.backspace="borrarEtiqueta"
				@keydown.down.prevent="next"
				@keydown.up.prevent="back"
				@keydown.enter.exact.prevent="select"
				@keydown.escape.prevent="$emit('cancel')"
				@focus="showList = true"
				v-model="model"
			>
			<span></span>
		</div>

		<div class="relative w-full">

			<ul class="list mobile" style="top: 8px;">

				<li v-for="(option, index) in filteredList"
					:style="{ backgroundColor: hover === index ? '#0077FF' : '', borderColor: hover === index ? '#0077FF' : '' }"
					:class="{ 'active': hover === index }"
					class="c-pointer"
					@mouseenter="hover = index"
					@mouseleave="hover = -1"
					@click="select"
				>

					{{ option.text }}

				</li>

			</ul>

		</div>

	</div>
</template>

<script>
	export default {

		name: 'Etiquetas',
		props: {
			placeholder: String,
			value: {
				type: [Array, String],
				default: () => []
			},
			active: Boolean,
			options: Array,

			listObject: Function,
			separador: {
				type: String,
				default: ' '
			}
		},
		data () {
			return {
				etiquetas: '',
				model: '',
				hover: -1,
				list: [],
				showList: false
			}
		},
		computed: {
			filteredList () {
				return this.list.filter(el => el.text.toLowerCase().indexOf(this.model.toLowerCase()) > -1).slice(0, 10)
			},
			arrayEtiquetas () {
				
				if (typeof this.value === 'object') return this.value

				return this.value.split(this.separador).filter(v => v !== '')

			}
		},
		watch: {

			model (val) {

				if (val.substring(val.length - this.separador.length) === this.separador) this.checkEtiquetas()


			},

			filteredList () {

				this.hover = -1

			}

		},
		async created () {

			if (this.options) {

				if (typeof this.options === 'function') {

					this.list = [
						{
							text: 'Cargando datos',
							value: ''
						}
					]

					this.list = await this.options()

				} else this.list = this.options

			}

		},
		methods: {
			focus () {

				this.$refs.input.focus()

			},
			checkEtiquetas (options = {}) {
				
				if(options.delete){
					this.$emit('save', this.arrayEtiquetas)

				} else {
					if (this.model !== '' && this.model !== ' ' && !this.value.includes(this.model.trim().toLowerCase())) {
						//const etiqueta = this.model.substring(0, this.model.length - this.separador.length).toLowerCase()
						const etiqueta = this.model.toLowerCase()
						let output = typeof this.value === 'object' ? [...this.value, etiqueta] : this.value + ';' + etiqueta
						
						this.$emit('save', output)
					}

					this.model = ''
				}


			},
			borrarEtiqueta () {
				
				if (this.model !== '' || this.value.length === 0) return

				this.model = this.value.pop()

			},
			close () {

				this.showList = false

			},
			hide () {

				this.showList = false

			},

			next () {

				this.hover = this.hover + 1 > this.filteredList.length - 1 ? 0 : this.hover + 1

			},
			back () {

				this.hover = this.hover - 1 < 0 ? this.filteredList.length - 1 : this.hover - 1

			},
			select () {
				
				const linea = this.filteredList[this.hover]

				if (linea) {
					this.model = linea.text + ' '
				}
				
				this.checkEtiquetas()

				this.list = []

				this.showList = false

			}
		}
	}
</script>

<style lang="scss" scoped>

	div.etiquetas {
		display: flex;
		align-items: center;
		list-style: none;
		flex-wrap: wrap;
		padding: .5em 0 0 0;
		input {
			padding-left: 0;
		}

		div.etiqueta {
			display: flex;
			align-items: center;
			border-radius: 5rem;
			color: white;
			margin: 0 .25rem .5rem 0;
			padding: .5rem 1rem .5rem .75rem;
			font-size: .75rem;

			svg {
				margin-right: .75em;
			}
		}

		div:not(.etiqueta) {
			flex-grow: 1;

			input {
				width: 100%;
				height: 100%;

				&:focus {
					outline: 0;
				}
			}
		}

	}

	.relative {
		position: relative;
	}

	.list {
		display: flex;
		flex-direction: column;
		padding-left: 0;
		margin-bottom: 0;
		box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
		overflow-x: hidden;
		left: 0;
		position: absolute;
		z-index: 900;
		width: 100%;

		li {
			position: relative;
			display: block;
			padding: .5rem 1rem;
			margin-bottom: -1px;
			background-color: #fff;
			border: 1px solid rgba(0, 0, 0, .125);
			font-size: .9rem;
			width: 100%;
			color: #495057;
			text-align: inherit;
			text-decoration: none;

			&:hover, &.active {
				z-index: 2;
				color: #FFF;
			}

			&:first-child {
				border-top-left-radius: .25rem;
				border-top-right-radius: .25rem;
			}

			&:last-child {
				margin-bottom: 0;
				border-bottom-right-radius: .25rem;
				border-bottom-left-radius: .25rem;
			}
		}
	}
	.input-etiqueta-wrapper{
		background-color: #0077FF;
		border-radius: 5rem;
		padding: .35rem 1rem .35rem .75rem;
		margin: 0 .5rem .5rem 0;
		position: relative;

		input[type="text"]{
			&::placeholder{
				color:#FFF;
				opacity: .9;
			}
			font-size: .75rem;
			color: #FFFFFF;
			background-color: #0077FF;
			caret-color: #FFF;

			&+span:after {
				z-index:2000;
				position: absolute;
				content: '';
				height: .1rem;

				bottom: .2rem;
				margin: 0 auto;
				left: 0;
				right: 0;
				width: calc(100% - 1.5rem);
				background: #FFF;
				opacity: .6;

				transition:.5s;
			}

			&:hover, &:focus{
				&+span:after {
					opacity: 1;
				}
			}
		}
	}


</style>
